<template>
    <v-form ref="form">
        <p class="text-h5">Профиль</p>
        <v-text-field
            name="user_name"
            class="mb-4"
            outlined
            dense
            v-model="form.user_name"
            placeholder="ФИО"
            persistent-hint
            single-line hint="ФИО">
        </v-text-field>
        <avatar :size="70"></avatar>
        <input name="avatar" type="file" accept="image/jpeg" class="mb-10">
<!--        <v-file-input-->
<!--            name="avatar"-->
<!--            v-model="form.avatar"-->
<!--            accept="image/png, image/jpeg, image/bmp"-->
<!--            placeholder="Изменить аватар"-->
<!--            label="Аватар"-->
<!--            prepend-icon=""-->
<!--        >-->
<!--            <template v-slot:prepend-inner>-->
<!--                <avatar></avatar>-->
<!--            </template>-->
<!--        </v-file-input>-->
        <v-text-field  v-for="(phone, index) in form.phones" :key="index"
            :label="'Телефон #' + (index + 1)"
            append-outer-icon="mdi-delete"
            @click:append-outer="onDeleteContactPhone(phone)"
            v-mask="'+7 (###) ### ## ##'"
            class="mb-4"
            outlined
            dense
            v-model="phone.contact"
            placeholder="Номер телефона"
            persistent-hint>
        </v-text-field>
        <div class="d-flex justify-center">
            <v-btn
                @click="onAddContactPhone"
                class="button-shadow"
                color="success"
            >
                Добавить номер телефона
            </v-btn>
        </div>
        <div class="d-flex justify-center mt-5">
            <v-spacer></v-spacer>
            <v-btn
                @click="onSave"
                class="button-shadow"
                color="primary"
            >
                Сохранить
            </v-btn>
        </div>
        <v-dialog v-if="deletePhone !== null" v-model="dialogPhoneDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Удалить номер {{deletePhone.contact}}?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDeletePhone">Отмена</v-btn>
              <v-btn color="blue darken-1" text @click="deletePhoneConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-overlay :value="isFetching" :absolute="true">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-form>
</template>

<script>
import * as apiUser from '@/api/user';
import { mapGetters, mapActions } from 'vuex';
import Avatar from "../user/Avatar.vue";
export default {
    name: 'UserProfile',
    components: {
        Avatar
    },
    data: () => ({
        isFetching: false,
        deletePhone: null,
        dialogPhoneDelete: false,
        form: {
            user_name: '',
            avatar: null,
            phones: [],
        },
        
    }),
    created () {
        this.load().then((res) => {
            this.setData(res);
        });
    },
    methods: {
        ...mapActions('user', ['UPDATE_USER']),
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
        onAddContactPhone(){
            this.form.phones.push({type: 'PHONE', contact: '', id: null});
        },
        closeDeletePhone(){
            this.deletePhone = null;
            this.dialogPhoneDelete = false;
        },
        async deletePhoneConfirm(){
            if( ! this.deletePhone.id ){
                let delIndex = this.form.phones.findIndex(phone => phone.contact === this.deletePhone.contact);
                if(delIndex !== -1){
                    this.form.phones.splice(delIndex, 1);
                } 
                this.closeDeletePhone();
                return;
            }
            try{
                await apiUser.contactRemove(this.deletePhone.id);
                this.SHOW_SUCCESS("Контакт успешно удален");
                let delIndex = this.form.phones.findIndex(phone => phone.id === this.deletePhone.id);
                if(delIndex !== -1){
                    this.form.phones.splice(delIndex, 1);
                }
                this.closeDeletePhone();
            }catch(e){
                console.log(e);
                this.SHOW_ERROR("Произошла ошибка удаления контакта")
            }
        },
        onDeleteContactPhone(phone){
            this.deletePhone = phone;
            this.dialogPhoneDelete = true;
        },
        async onSave(){
            this.isFetching = true;
            const formData = new FormData(this.$refs.form.$el);
            formData.append('phones', JSON.stringify(this.form.phones));
            try{
                let response = await apiUser.profileUpdate(this.USER_ID, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.form.avatar = null;
                let data = await this.load();
                this.setData(data);
                this.SHOW_SUCCESS(response.data.message);
            }catch(err){
                this.SHOW_SUCCESS('Ошибка обновления');
                console.log(err);
            }finally{
                this.isFetching = false;
                this.UPDATE_USER();
            }
        },
        setData(userData){
            this.form.user_name = userData.name;
            this.form.phones.splice(0, this.form.phones.length, ...userData.contacts);
        },
        async load(){
            this.isFetching = true;
            try{
                let response = await apiUser.profile(this.USER_ID);
                return response.data;
            }catch(err){
                console.log(err);
            }finally{
                this.isFetching = false;
            }
        },
        setForm(data){
            this.form.user_name = data.name;
        }
    },
    computed:{
        ...mapGetters('user', ['USER_ID'])
    },
}
</script>